import { render, staticRenderFns } from "./AdesaoGateModal.vue?vue&type=template&id=32088952"
import script from "./AdesaoGateModal.vue?vue&type=script&lang=js"
export * from "./AdesaoGateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports